import { render, staticRenderFns } from "./ManifestBKM.vue?vue&type=template&id=3874e56c&"
import script from "./ManifestBKM.vue?vue&type=script&lang=js&"
export * from "./ManifestBKM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports